import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Unslop Studio",
    description: "Professional AI UGC ads that don't look like AI. Human-written hooks, your real product, and a 23-point slop check on every cut.",
    placeholder: 'Your new site will appear right here. Just ask Modulify to generate anything you can describe.',
    url: getOrigin()
}

export const navLinks = [
    { label: 'Work', href: '/work' },
    { label: 'The standard', href: '/#standard' },
    { label: 'Process', href: '/#process' },
    { label: 'Packages', href: '/#packages' },
    { label: 'FAQ', href: '/#faq' }
]
